import { fade } from '@material-ui/core/styles/colorManipulator';

/**
 * Native-style PDF layout; colors from admin v3 theme tokens. Page width / font scaling stays
 * in JS (`pdf-viewer.js` + react-pdf `width`).
 */
export default (theme) => {
  const { greyScale, primary } = theme.palette;
  /** Dark strip: learner uses `charcoal`; admin v3 uses `grey130` as the closest viewer chrome. */
  const canvas = greyScale.charcoal ?? greyScale.grey130 ?? primary.black;
  const mutedOnCanvas = greyScale[90] ?? greyScale.morningBlue ?? primary.white;
  const shadowColor = fade(primary.black, 0.35);

  return {
    root: {
      width: '100%',
      height: '100%',
      minHeight: 0,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      minHeight: 200,
      padding: '32px 24px',
      gap: 16,
      boxSizing: 'border-box',
      backgroundColor: canvas,
    },
    loadingText: {
      color: mutedOnCanvas,
    },
    loadingSpinner: {
      color: mutedOnCanvas,
    },
    error: {
      color: primary.white,
      textAlign: 'center',
    },
    pdfViewerChrome: {
      position: 'relative',
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
      overscrollBehavior: 'contain',
      boxSizing: 'border-box',
      backgroundColor: canvas,
    },
    loadingOverlay: {
      position: 'absolute',
      inset: 0,
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      backgroundColor: fade(canvas, 0.92),
    },
    pdfPageStack: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: '100%',
      padding: '12px 8px 24px',
      boxSizing: 'border-box',
    },
    pdfDocument: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: '100%',
      '& .react-pdf__message': {
        color: primary.white,
      },
    },
    pdfPage: {
      flexShrink: 0,
      maxWidth: '100%',
      marginBottom: 16,
      boxSizing: 'border-box',
      boxShadow: `0 2px 6px ${shadowColor}`,
      '&:last-child': {
        marginBottom: 0,
      },
      '& .react-pdf__Page': {
        display: 'block',
      },
      '& .react-pdf__Page__svg, & svg': {
        maxWidth: '100% !important',
        height: 'auto !important',
        display: 'block',
      },
    },
  };
};
